<template>
  <div class="page-container">
    <h1>查看报表</h1>
    <div
      v-show="showReport()"
      class="user-options clearfix"
      style="margin-top: 40px"
    >
      <el-form ref="form" label-width="80px" size="medium">
        <el-form-item label="报表">
          <el-date-picker
            v-model="dateValue"
            value-format="yyyy-MM-dd"
            type="date"
            :picker-options="pickerOptions"
            placeholder="选择日期"
          >
          </el-date-picker>
          <el-button type="primary" @click="downloadReport">下载</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="user-options clearfix">
      <el-form ref="form" label-width="80px" size="medium">
        <el-form-item label="注册主播">
          <el-date-picker
            class="time-picker"
            v-model="datePicked2"
            type="daterange"
            align="right"
            :unlink-panels="true"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions2"
          >
          </el-date-picker>
          <el-button type="primary" @click="downloadActors">下载报表</el-button>
          <el-button type="primary" @click="downloadAllActors"
            >下载全部</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ReportPage',
  components: {},
  data() {
    return {
      dateValue: this.$store.getters.dateOneDayBefore,
      pickerOptions: {
        disabledDate(date) {
          let dateNow = new Date()
          dateNow.setDate(dateNow.getDate() - 1)
          if (date.getTime() > dateNow.getTime()) {
            return true
          }
        }
      },
      pickerOptions2: {
        disabledDate(date) {
          let dateNow = new Date()
          dateNow.setDate(dateNow.getDate())
          if (date.getTime() > dateNow.getTime()) {
            return true
          }
        }
      },
      datePicked2: [
        this.$store.getters.dateOneWeekBefore,
        this.$store.getters.dateNow
      ]
    }
  },
  beforeCreate() {},
  created() {},
  mounted() {},
  computed: {
    username() {
      return this.$store.getters.username
    },
    userLevel() {
      return this.$store.getters.userLevel
    },
    token() {
      return this.$store.getters.token
    },
    isAdmin() {
      return this.$store.getters.isAdmin
    }
  },
  watch: {},
  methods: {
    // 下载报表
    downloadReport() {
      window.location.href =
        this.$store.getters.path.reports_download_report + this.dateValue
    },
    // 生成并下载主播excel
    downloadActors() {
      window.location.href =
        this.$store.getters.path.reports_download_actors +
        '?token=' +
        this.token +
        '&start=' +
        this.datePicked2[0] +
        '&end=' +
        this.datePicked2[1] +
        '&username=' +
        this.username
    },
    // 生成并下载全部主播
    downloadAllActors() {
      window.location.href =
        this.$store.getters.path.reports_download_actors +
        '?token=' +
        this.token +
        '&username=' +
        this.username
    },
    showReport() {
      return this.$store.getters.isAdmin
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  h1 {
    font-size: 28px;
    font-weight: bold;
  }
}

.user-options {
  margin-top: 10px;

  button {
    margin-left: 30px;
  }
}
</style>
